module.exports = __webpack_public_path__ + "img/finished-clock-alert-outline.5d568f93.svg";